import {
    DateValue
} from "@comp/index.js";
import ItemListView from "../../../components/ItemListView/ItemListView.vue"
import ItemView from "../../../components/ItemView/ItemView.vue"
import changeRequestAttachable from "../ChangeRequests/attachable";
import {
    reviseWorkInstruction
} from "./actions";

export default [{
    "path": "/Database/WorkInstructions",
    "component": { ...ItemListView },
    "name": "Work Instructions",
    "meta": {
        "app": "Database",
        "name": "Work Instructions",
        "sideNav": true,
        "sideNavSection": "Quality System",
        "appSwitcher": false,
        "icon": "database",
        "tableSettings": "WorkInstructions",
        "dataPath": "Database/WorkInstructions",
        "selectionRoute": "Database/WorkInstructions/{ID}",
        "menuActions": [],
        lock(user) {
            return [user?.Security?.Database?.Read !== true, "Cannot view this area"]
        }
    }
}, {
    "path": "/Database/WorkInstructions/:id",
    "component": ItemView,
    "name": "WorkInstruction",
    "meta": {
        "app": "Database",
        "name": "WorkInstructios",
        "dataPath": "Database/WorkInstructions",
        "dataPathOverride": "Database/WorkInstructions/:id",
        "selectionRoute": "Database/WorkInstructions/{ID}",
        "storeData": ["Database/MFARQuestions"],
        title(item) {
            return `Work Instruction: ${item.Number}`;
        },
        "attachedItems": {
            "More Data": {
                "attachables": [{
                    "label": "Revisions",
                    "key": "Revisions",
                    "local": true,
                    "headers": [{
                        "headerName": "Revision",
                        "field": "Revision",
                        "sort": "asc",
                        "type": "number",
                        "filter": "agNumberColumnFilter"
                    }, {
                        "headerName": "Date",
                        "field": "Date",
                        "filter": "agDateColumnFilter",
                        "cellRenderer": DateValue
                    }],
                    "rowActions": [{
                        "label": "Download",
                        "action": async ({ rowItem, pageItem, db }) => {
                            let url = await db.download(`Database/Handbooks/${pageItem.HandbookID}/Procedures/${pageItem.ID}/Revisions/${rowItem.ID}/${rowItem.File}`);
                            window.open(url);
                        }
                    }],
                    "actions": [{
                        "label": "Revise Work Instruction",
                        "action": reviseWorkInstruction
                    }]
                }, changeRequestAttachable]
            }
        },
        "dataFields": [{
            "label": "Number",
            "key": "Number"
        }, {
            "label": "Title",
            "key": "Title",
            "class": "col-span-2"
        }, {
            "label": "Revision",
            "key": "Revision"
        }, {
            "label": "Handbook",
            "key": "Handbook",
            "link": "Database/Handbooks/:HandbookID"
        }],
        "menuActions": []
    }
}];
